import { Children, useEffect, useState } from 'react'
import styled from 'styled-components'
import range from 'lodash/range'

import { colors } from '@/styles'

const buttonColor = '#4c4c4c'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  > button:not(:last-of-type) {
    margin-right: 10px;
  }
`

const Slide = styled.button`
  padding: 30px 5px;
  background: none;
  border: none;
  div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${colors.grey};
  }
  &[aria-current='step'] {
    div {
      background: ${buttonColor};
      border-color: ${buttonColor};
    }
  }
`

const Slider = ({ children: rawChildren, label, delay = 6500 }) => {
  const [page, setPage] = useState(0)
  const amount = Children.count(rawChildren)
  const children = Children.toArray(rawChildren)
  const current = children[page]
  useEffect(() => {
    const id = setInterval(() => setPage(cur => (cur + 1) % amount), delay)
    return () => clearInterval(id)
  }, [delay, amount, page])
  if (amount <= 0) return null
  const buttons = range(amount).map(key => (
    <Slide
      aria-current={key === page ? 'step' : undefined}
      aria-label={label ? label(key + 1) : undefined}
      onClick={() => setPage(key)}
      key={key}
    >
      <div></div>
    </Slide>
  ))
  return (
    <Wrapper>
      {current}
      <ButtonWrapper>{buttons}</ButtonWrapper>
    </Wrapper>
  )
}

export default Slider
